const parseCookie = (str: string): Record<string, string> => {
    try {
        return str
            .split(";")
            .map((v) => v.split("="))
            .reduce(
                (acc, v) => {
                    acc[decodeURIComponent(v[0].trim())] = decodeURIComponent(v[1].trim());
                    return acc;
                },
                {} as Record<string, string>
            );
    } catch {
        return {};
    }
};

export default parseCookie;
